import parse from "html-react-parser";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const Footer = (props: { login?: boolean }) => {
    const { login = false } = props;
    const { t } = useTranslation();

    return (
        <footer className="pb-5 mt-auto no-print">
            {login ? (
                <div className="container">
                    <div className="row justify-content-center mt-3">
                        <div className="col-auto text-center mb-2 mb-md-0">
                            <Link className="text-body" to="/personvern">{t('privacy')}</Link>
                        </div>
                        <div className="col-auto text-center">
                            <Link className="text-body" to="/informasjonskapsler">{t('cookies')}</Link>
                        </div>
                    </div>

                    <div className="row justify-content-center mt-3">
                        <div className="col-auto text-center">
                            <Link className="text-body opacity-50" to="https://www.lyfti.no" target="_blank">Lyfti søknadsportal</Link>
                            <small className="text-tertiary d-block mt-2" style={{ color: 'var(--bs-tertiary-color)' }}>v{__APP_BUILD_ID__}</small>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <hr className="border mt-4 mt-lg-5 mb-5 mb-lg-0" />
                    <div className="container">
                        <div className="row d-lg-none">
                            <Logo contain="center" />
                        </div>
                        <div className="row mt-3 justify-content-center justify-content-md-start">
                            <div className="col-auto">
                                <Link className="text-body" to="/personvern">{t('privacy')}</Link>
                            </div>
                            <div className="col-auto">
                                <Link className="text-body" to="/informasjonskapsler">{t('cookies')}</Link>
                            </div>
                            <div className="col-12 col-md mt-4 mt-md-0 d-flex justify-content-center justify-content-md-end">
                                <span className="text-tertiary" style={{ color: 'var(--bs-tertiary-color)' }}>{parse(t('service_delivered_by'))} · v{__APP_BUILD_ID__}</span>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </footer>
    )
};

export default Footer;